import { gql } from "generated-graphql";

export const GET_SCOUT_CONVERSATION_CONTEXT_SUMMARY_FOR_STAFF = gql(`
  query GetScoutConversationContextSummaryForStaff($conversationId: ID!) {
    getScoutConversationContextSummaryForStaff(conversationId: $conversationId) {
      conversationId
      partCount
      roundtripCount
      turnCount
      documentAttachmentCount
      totalEstimatedTokens
      breakdown {
        type
        toolName
        count
        estimatedTokens
      }
      cache {
        cacheReadTokens
        cacheWriteTokens
        totalInputTokens
      }
      latestInputTokens
      peakInputTokens
      totalOutputTokens
      totalThinkingTokens
      totalRoundtripCostUsd
      documentAttachmentTotalEstimatedCostUsd
      latestPrelude {
        turnNumber
        systemPromptTokens
        toolDefinitionsTokens
      }
    }
  }
`);

export const GET_SCOUT_CONVERSATION_CONTEXT_ROUNDTRIPS_FOR_STAFF = gql(`
  query GetScoutConversationContextRoundtripsForStaff($conversationId: ID!) {
    getScoutConversationContextRoundtripsForStaff(conversationId: $conversationId) {
      conversationId
      turns {
        messageId
        seq
        turnNumber
        roundtripIndex
        requestId
        traceId
        createdAt
        provider
        model
        inputTokens
        outputTokens
        thinkingTokens
        cacheReadTokens
        cacheWriteTokens
        systemPromptTokens
        toolDefinitionsTokens
        conversationHistoryTokens
        estimatedCostUsd
        compactionApplied
        compactionLocus
        compactionJson
      }
    }
  }
`);

export const GET_SCOUT_CONVERSATION_CONTEXT_PARTS_FOR_STAFF = gql(`
  query GetScoutConversationContextPartsForStaff(
    $conversationId: ID!
    $page: Int
    $pageSize: Int
    $partType: String
  ) {
    getScoutConversationContextPartsForStaff(
      conversationId: $conversationId
      page: $page
      pageSize: $pageSize
      partType: $partType
    ) {
      conversationId
      count
      items {
        id
        conversationId
        messageId
        seq
        type
        streamPartId
        stepIndex
        agentState
        text
        toolName
        toolDisplayName
        toolCallId
        toolState
        toolInput
        toolOutput
        toolError
        toolTokenEstimate
        toolInputTokens
        toolDurationMs
        sourceId
        url
        title
        mediaType
        filename
        createdAt
        estimatedTokens
        message {
          id
          role
          seq
          requestId
          createdAt
        }
      }
    }
  }
`);

export const GET_SCOUT_CONVERSATION_TURN_CONTEXTS_FOR_STAFF = gql(`
  query GetScoutConversationTurnContextsForStaff($conversationId: ID!) {
    getScoutConversationTurnContextsForStaff(conversationId: $conversationId) {
      turnNumber
      text
    }
  }
`);

export const GET_SCOUT_CONVERSATION_CONTEXT_DOCUMENTS_FOR_STAFF = gql(`
  query GetScoutConversationContextDocumentsForStaff(
    $conversationId: ID!
    $page: Int
    $pageSize: Int
  ) {
    getScoutConversationContextDocumentsForStaff(
      conversationId: $conversationId
      page: $page
      pageSize: $pageSize
    ) {
      conversationId
      count
      totalEstimatedCostUsd
      items {
        attachmentId
        privateDocumentId
        filename
        title
        ingestionMode
        extractionStatus
        pageCount
        createdAt
        previewModel
        previewInputTokens
        previewOutputTokens
        extractionModel
        extractionInputTokens
        extractionOutputTokens
        previewCostUsd
        extractionCostUsd
        estimatedCostUsd
      }
    }
  }
`);

export const GET_SCOUT_CONVERSATION_CONTEXT_PRELUDE_FOR_STAFF = gql(`
  query GetScoutConversationContextPreludeForStaff($conversationId: ID!) {
    getScoutConversationContextPreludeForStaff(conversationId: $conversationId) {
      conversationId
      prelude {
        turnNumber
        systemPromptTokens
        toolDefinitionsTokens
        systemPromptText
        toolDefinitionsJson
        allowedSkillsJson
      }
    }
  }
`);
